import React, { ComponentProps } from "react";

type IconProps = Omit<ComponentProps<"img">, "src">;

export function IconStar({ loading = "lazy", ...props }: IconProps) {
  return <img {...props} loading={loading} src="/images/icons/ScanStar.png" />;
}
